import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { VisibilityBadge } from "app/pages/sales-intelligence/common-components/VisibilityBadge/VisibilityBadge";

import { PlaybookSummaryBadgeCard } from "./PlaybookSummaryBadgeCard";

export type PlaybookSummaryEmployeeProfileItem = {
    profileId: string;
    profileName: string;
    isShared: boolean;
};

type PlaybookSummaryEmployeeProfilesProps = {
    profiles: readonly PlaybookSummaryEmployeeProfileItem[];
    noneEnabledLabel: string;
};

export const PlaybookSummaryEmployeeProfiles = ({
    profiles,
    noneEnabledLabel,
}: PlaybookSummaryEmployeeProfilesProps) => {
    if (profiles.length === 0) {
        return (
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon["400"]}
            >
                {noneEnabledLabel}
            </Text>
        );
    }

    return (
        <Flex
            flexWrap="wrap"
            gap="8px"
            data-automation="playbook-summary-employee-profiles-list"
        >
            {profiles.map(({ profileId, profileName, isShared }) => (
                <PlaybookSummaryBadgeCard
                    key={profileId}
                    label={profileName}
                    dataAutomation={`playbook-summary-employee-profile-${profileId}`}
                    badge={
                        <VisibilityBadge
                            isShared={isShared}
                            dataAutomationSuffix={profileId}
                        />
                    }
                />
            ))}
        </Flex>
    );
};
